import { CollectionRuleType, CollectionRuleResponse } from "@authory-packages/core";

export const generateCollectionRules = (sources: string[], types: string[], text: string) => {
    const computedRules: CollectionRuleResponse[] = [];

    if (text?.length) {
        text.split(",")
            .map((val) => val.trim())
            .filter((val) => !!val.length)
            .forEach((val) =>
                computedRules.push({
                    id: "",
                    type: CollectionRuleType.Keyword,
                    params: [val]
                })
            );
    }

    sources.forEach((val) =>
        computedRules.push({
            id: "",
            type: CollectionRuleType.Source,
            params: [val]
        })
    );

    types.forEach((val) => {
        const splitTypes = val.split("$");

        splitTypes.forEach((type) =>
            computedRules.push({
                id: "",
                type: CollectionRuleType.Type,
                params: [type]
            })
        );
    });

    return computedRules;
};
